























import {
  InstrumentPerformanceData,
  InstrumentPerformanceGraphPoint,
  InstrumentPerformanceGraphTimePeriod,
} from "@/shared/types";
import { Component, Prop, Vue } from "@/shared/vuepack";
import { GChart } from "vue-google-charts";
import { formatCurrency } from "@/shared/currency";
import { useInstrumentPerformanceDataStore } from "@/shared/store/instrumentPerformanceData";

interface GraphSelectOption {
  label: string;
  value: InstrumentPerformanceGraphTimePeriod;
}

@Component({
  computed: {
    InstrumentPerformanceGraphTimePeriod () {
      return InstrumentPerformanceGraphTimePeriod;
    }
  },
  components: {
    GChart,
  }
})
export default class InstrumentPerformanceGraph extends Vue {
  @Prop() symbol: string;
  @Prop() accountId: number;

  instrumentPerformanceDataStore = useInstrumentPerformanceDataStore();

  formatCurrency = formatCurrency;

  selectedGraphTimePeriod = InstrumentPerformanceGraphTimePeriod.Days5;

  get chartOptions (): any {
    return {
      colors: ["#00af89", "#00af89"],
      legend: {position: "none"},
      height: "100%",
      chartArea: {
        top: "5%",
        left: "10%",
        width: "80%",
        height: "85%",
      },
      hAxis: {
        format: this.horizontalAxisFormatter,
        gridlines: {
          color: "transparent"
        },
        baselineColor: "black"
      },
      vAxis: {
        format: "currency",
        gridlines: {
          color: "transparent"
        },
        baselineColor: "black",
        minValue: 0,
        viewWindowMode: "pretty"
      },
      tooltip: {
        isHtml: true
      }
    };
  }

  get horizontalAxisFormatter (): string {
    switch (this.selectedGraphTimePeriod) {
      case InstrumentPerformanceGraphTimePeriod.Days1:
        return "E H:mm a";
      case InstrumentPerformanceGraphTimePeriod.Days5:
        return "E MM/dd";
      case InstrumentPerformanceGraphTimePeriod.Months1:
        return "MM/dd/yyyy";
      case InstrumentPerformanceGraphTimePeriod.Months3:
        return "MM/dd/yyyy";
      case InstrumentPerformanceGraphTimePeriod.Months6:
        return "MM/dd/yyyy";
      case InstrumentPerformanceGraphTimePeriod.YearToDate:
        return "MM/dd/yyyy";
      case InstrumentPerformanceGraphTimePeriod.Years1:
        return "MM/yyyy";
      case InstrumentPerformanceGraphTimePeriod.Years3:
        return "MM/yy";
      case InstrumentPerformanceGraphTimePeriod.Years5:
        return "MM/yy";
      default:
        return "MM/dd/yyyy";
    }
  }

  get graphTimePeriodOptions (): GraphSelectOption[] {
    return [
      {
        label: "1 Day",
        value: InstrumentPerformanceGraphTimePeriod.Days1
      },
      {
        label: "5 Day",
        value: InstrumentPerformanceGraphTimePeriod.Days5
      },
      {
        label: "1 Month",
        value: InstrumentPerformanceGraphTimePeriod.Months1
      },
      {
        label: "3 Months",
        value: InstrumentPerformanceGraphTimePeriod.Months3
      },
      {
        label: "6 Months",
        value: InstrumentPerformanceGraphTimePeriod.Months6
      },
      {
        label: "YTD",
        value: InstrumentPerformanceGraphTimePeriod.YearToDate
      },
      {
        label: "1 Year",
        value: InstrumentPerformanceGraphTimePeriod.Years1
      },
      {
        label: "3 Years",
        value: InstrumentPerformanceGraphTimePeriod.Years3
      },
      {
        label: "5 Years",
        value: InstrumentPerformanceGraphTimePeriod.Years5
      }
    ];
  }

  get instrumentPerformanceData (): InstrumentPerformanceData {
    return this.instrumentPerformanceDataStore.instrumentPerformanceData(this.symbol);
  }

  get dataPointsForTimePeriod (): InstrumentPerformanceGraphPoint[] {
    if (this.instrumentPerformanceData) {
      return this.instrumentPerformanceData.graphDataPoints[this.selectedGraphTimePeriod];
    }

    return [];
  }

  updateGraphTimePeriod (timePeriod: InstrumentPerformanceGraphTimePeriod): void {
    this.selectedGraphTimePeriod = timePeriod;
  }
}
